/**
 * Author: Charuka Rathnayaka
 * Email: CharukaR@99x.io
**/

import { BasicLLMInferenceEngine } from "@optimaxer/web-core";

export abstract class AbstractDataExtractor {
  /**
   * extractData
   * This function extracts data from the given text based on the schema.
   * @param text The text to extract data from.
   * @param schema The schema to extract data based on.
   */
  abstract extractData(text: string, schema: { [key: string]: any }, llmInstance: BasicLLMInferenceEngine): Promise<{ [key: string]: any }>;
}